// equalize-height.js
;(({ $, $$}) => {
    CNS.$fns.equalizeHeights = function () {
        const prims = $$('.equalize-height[primary]')
        
        prims.forEach(prim => {
            const bindName = prim.dataset.bindName
            const removeHeightBr = parseInt(prim.dataset.removeHeightBr)
            const subs = $$(`.equalize-height[secondary][data-bind-name="${bindName}"]`)
            const targets = [
                prim,
                ...Array.from(subs)
            ]

            removeHeight(targets)

            if (window.innerWidth <= removeHeightBr) {
                return
            }

            const heightToSet = getMaxHeight(targets)
            setHeights(targets, heightToSet)
            // console.log(heightToSet)
        })
    }

    let resizeTimer = null
    const resizeDelay = 200

    window.addEventListener('resize', () => {
        clearTimeout(resizeTimer)
        resizeTimer = setTimeout(() => {
            CNS.$fns.equalizeHeights()
        }, resizeDelay)
    })

    function getMaxHeight(targets) {
        let maxHeight = 0

        targets.forEach(t => {
            maxHeight = Math.max(maxHeight, t.offsetHeight)
        })

        return maxHeight
    }

    function removeHeight(targets) {
        // targets.forEach(t => t.removeAttribute('style'))
        targets.forEach(t => t.style.height = 'auto')
    }

    function setHeights(targets, heightToSet) {
        targets.forEach(t => {
            t.style.height = `${heightToSet}px`
        })
    }

})(CNS);